module.exports = __webpack_public_path__ + "static/media/lab.9eb6c312.webp";